import * as XLSX from 'xlsx-js-style';
import autoFitColumns from './autoFitColumns';

export default function formatWorksheet(
    worksheet,
    rows,
    options = {}
) {

    worksheet['!cols'] = autoFitColumns(
        rows,
        options
    );

    const range = XLSX.utils.decode_range(
        worksheet['!ref']
    );

    for (
        let row = range.s.r;
        row <= range.e.r;
        row++
    ) {

        for (
            let col = range.s.c;
            col <= range.e.c;
            col++
        ) {

            const cellAddress =
                XLSX.utils.encode_cell({
                    r: row,
                    c: col
                });

            const cell = worksheet[cellAddress];

            if (!cell) {
                continue;
            }

            cell.s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: false
                },
                ...(row === 0 && {
                    font: {
                        bold: true
                    }
                })
            };

        }

    }

    return worksheet;

}